import CPReportSelector from '../../cp_selector/cp_selector_report_config'
import messageResource from '../../messageResource'
import TableTooltip from '../../controls/TableTooltip'
import {calculateTooltipOffset} from '../../atBrowserUtils'
import $ from 'jquery'
import _ from 'underscore'
import DropdownListButton from '../../controls/dropdown_list_button'
import {ReportGroupingLevel} from '../constants'
import GroupType from '../../enums/GroupType'
import {Feature, isEnabled} from '../../features'
import {TimeApprovalStatus, TimeFormat} from 'constants'
import ReportTimeTrackStatusFilter from '../../controls/ReportTimeTrackStatusFilter'
import ReportUserSelectorButton from '../../controls/ReportUserSelectorButton'
import ErrorTooltipsForSectionsController from '../ErrorTooltipsForSectionsController'
import View from '../../View'

export default class ReportEditConfigController extends View {
    constructor() {
        super()

        this.state = {
            loggedInUserId: null
        }
    }

    init(config) {
        super.init()
        this.productSettingsValidator = _.isUndefined(config.productSettingsValidator) ? new ATProductSettingsValidator() : config.productSettingsValidator;
        this.reportRightsValidator = _.isUndefined(config.reportRightsValidator) ? new ATReportRightsValidator() : config.reportRightsValidator;
        this.initReportParameters = config.reportParameters;

        this.panelId = config.panelId ? config.panelId : "editReportConfigurationPanel";
        this.panelEl = $("#" + this.panelId);

        this.errorsToSectionElsMap = this.initErrorsToSectionElsMap();

        const self = this;
        this.errors = [];
        this.errorMessageEl = this.panelEl.find(".errorMessage" );
        this.errorTooltipsForSectionsController = new ErrorTooltipsForSectionsController().init( "reportEditConfigErrorTooltip",
            this.errorsToSectionElsMap,
            function( error ) { return self.getErrorMessage( error ); } );

        this._initTimeFormatTooltip();

        this.preloadedState = {
            initCPSelector: function ( cpSelector ) {
                cpSelector.initializeData(config.cpList, config.customersWithMaIds, config.projectsWithMaIds);
            },
            initUserSelector: function ( userSelector ) {
                userSelector.initializeData(config.userGroups != null,
                    config.timeZoneGroups != null,
                    config.users,
                    config.manageableUsersIds,
                    config.userGroups,
                    config.timeZoneGroups);
            }
        };
    }
}

ReportEditConfigController.prototype.possibleErrors = {
    ERROR_EMPTY_USER_SELECTION: "errorEmptyUserSelection",
    ERROR_EMPTY_CP_SELECTION: "errorEmptyCPSelection",
    ERROR_EMPTY_LEAVE_TYPES_SELECTION: "errorEmptyLeaveTypesSelection",
    ERROR_IN_GROUPING_LEVELS_SELECTOR: "errorInGroupingLevelsSelector",
    ADDITIONAL_ERROR: "additionalError"
};

/**
 * Set default values for selectors are dependent on features
 */
ReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function() {
    // abstract
};

ReportEditConfigController.prototype.makeCPSelector = function ( customersProjectsSelection ) {
    const self = this;
    const configChanged = function () {
        self.removeCPSelectionError()
        cpSelector.setInitialValueFromCurrent()
        self.configChanged()
    }

    const cpSelector = new CPReportSelector().init( customersProjectsSelection,
                                                  "cpSelectorId", configChanged );
    this.preloadedState.initCPSelector(cpSelector);

    cpSelector.panel.on("change", function() {
        cpSelector.setWasChanged();
    });

    return cpSelector;
};

ReportEditConfigController.prototype.adjust = function(groups, groupType, users, showDisabled)
{
    let adjustUsers;
    if (!showDisabled)
        users = _.filter(users, function(user) { return user.active; });

    if (groupType === "USER_GROUP")
    {
        adjustUsers = _.filter(users, function(user) { return _.contains(groups, user.userGroupId)});
    }
    if (groupType === "TIME_ZONE_GROUP")
    {
        adjustUsers = _.filter(users, function(user) { return _.contains(groups, user.timeZoneGroupId)});
    }
    return _.map(adjustUsers, function(user) { return user.id; });
};


ReportEditConfigController.prototype.makeUserSelector = function ( config, specificConstructorPanel ) {
    const self = this;
    const configChanged = function () { self.removeUserSelectionError(); self.configChanged(); };

    const userSelection = config.reportParameters.userSelection
    const ugrEnabled = this.productSettingsValidator.isUGREnabled()
    const tzgEnabled = this.productSettingsValidator.isTZGEnabled()
    const ugrWithoutFeature = !ugrEnabled && config.reportParameters.userSelection.groupType === GroupType.USER_GROUP
    const tzgWithoutFeature = !tzgEnabled && config.reportParameters.userSelection.groupType === GroupType.TIME_ZONE_GROUP
    const groupsSelected = config.reportParameters.userSelection.selectedGroups.length > 0

    if (((ugrWithoutFeature || tzgWithoutFeature)) && (groupsSelected)
        || userSelection.includeUserTeamOnly && (ugrEnabled || tzgEnabled)) {

        userSelection.selectedUsers = userSelection.selectedUsers.concat(self.adjust(userSelection.selectedGroups,
                                                                                     userSelection.groupType,
                                                                                     config.users,
                                                                                     userSelection.showDisabled));
        userSelection.selectedGroups = [];
    }

    const selectorConfig = {
        selectorId: "userSelectorId",
        userSelection: userSelection,
        changeCallback: () => {
            userSelector.setInitialValueFromCurrent()
            configChanged()
        },
        needAdditionalCheckbox : config.needAdditionalCheckbox !== undefined ? config.needAdditionalCheckbox : true,
        additionalCheckboxLabel: config.additionalCheckboxLabel || messageResource.getMessage("users_selector.reports.include_users_wo_time"),
        allUsersAvailable: config.reportAuthorizationInfo.allUsersAvailable,
        includeUserTeamOnly: userSelection.includeUserTeamOnly
    };

    if ( specificConstructorPanel )
        selectorConfig.specificConstructorPanel = specificConstructorPanel;

    const userSelector = new ReportUserSelectorButton().init(selectorConfig);

    userSelector.initializeData(
            config.userGroups != null,
            config.timeZoneGroups != null,
            config.users,
            config.manageableUsersIds,
            config.userGroups,
            config.timeZoneGroups,
            userSelection.includeUserTeamOnly
    )

    userSelector.panel.on("change", function() {
        userSelector.setWasChanged();
    });

    userSelector.panel.loggedInUserNotInTeam = !!config.manageableUsersIds
                                               && config.manageableUsersIds.indexOf(this.state.loggedInUserId) === -1
                                               && config.users.some(u => u.id === this.state.loggedInUserId)

    userSelector.updateButton()

    return userSelector;
};

ReportEditConfigController.prototype.getConfig = function () {
    // abstract
};

ReportEditConfigController.prototype.resetConfig = function ( config ) {
    // abstract
};

ReportEditConfigController.prototype.hasErrors = function () {
    return this.errors.length > 0;
};

ReportEditConfigController.prototype.setConfigButtonHandlers = function ( handlers ) {
    $("#applyReportConfiguration").click(function () {handlers.onApply();});
    $("#cancelReportConfiguration").click(function () {handlers.onCancel();});
};

ReportEditConfigController.prototype.initListSelector = function ( selectId, initValue, changeCallback, additionalClass )
{
    const selector = this.initCustomListSelector( selectId, changeCallback, additionalClass );
    selector.setActiveItemByValue(initValue);

    return selector;
};

ReportEditConfigController.prototype.initTimeFormatSelector = function(timeFormat, changedCallback){
    return this.initListSelector("timeFormatSelect", timeFormat, changedCallback, "timeFormatMenu");
};

ReportEditConfigController.prototype._initTimeFormatTooltip = function() {
    // init tooltip for time format selector
    const timeFormatTooltip = new TableTooltip().init("timeFormatTooltip");
    const icon = $("#timeFormatInfo");
    icon.hover(function(event) {timeFormatTooltip.show(); timeFormatTooltip.move(calculateTooltipOffset( timeFormatTooltip, event ))}, function() {timeFormatTooltip.hide()});
    icon.mousemove(function(event) { timeFormatTooltip.move(calculateTooltipOffset( timeFormatTooltip, event ))});
};

ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    this.initReportParameters = this.getConfig();
};

ReportEditConfigController.prototype.setSelectorsFromReportParameters = function (reportParameters) {
    this.initReportParameters = reportParameters;
};

ReportEditConfigController.prototype.addApprovedTTFilter = function ( initValue, changeCallback )
{
    const isNeedApprovedTTFilter = isEnabled(Feature.TTA) || (initValue && initValue !== TimeApprovalStatus.BOTH);
    const selectorRow = $("#ttStatusFilterRow");
    if (isNeedApprovedTTFilter) {
        selectorRow.show();
        return new ReportTimeTrackStatusFilter().init( "filterByTTStatus", initValue, changeCallback )
    } else {
        selectorRow.hide();
        return this.initEmptyListSelector(initValue);
    }
};

ReportEditConfigController.prototype.initEmptyListSelector = function( initValue) {
    return { getValue: function(){ return initValue; }, setActiveItemByValue: function() {} };
};

ReportEditConfigController.prototype.initRadioGroupSelector = function ( radioGroupSelectorId, radioGroupName, initValue, onChangeCallback )
{
    const selector = $("#" + radioGroupSelectorId);
    selector.groupName = radioGroupName;
    selector.setItemByValue = function(value){
        this.find("[name=" + selector.groupName + "][value=" + value +"]").prop( 'checked', true );
    };

    selector.getValue= function ()
    {
        return this.find("[name=" + selector.groupName + "]:checked").val();
    };
    selector.setItemByValue(initValue);

    if ( onChangeCallback )
        selector.on("change", onChangeCallback);

    return selector;
};


ReportEditConfigController.prototype.initCustomListSelector = function ( selectId, onChangeCallback, additionalCls, initValue )
{
    let menuCls = "columns-format-menu";
    menuCls += additionalCls ? " " + additionalCls : "";
    const selector = new DropdownListButton( {
                                                  applyTo: selectId,
                                                  menuCls: menuCls,
                                                  cls: "report-config-control-button"
                                              } );

    if( initValue) {
        selector.setActiveItemByValue(initValue);
    }

    if( onChangeCallback != null )
        selector.on("change", onChangeCallback );

    return selector;
};
// method for grouping level selectors (check if selector contains concrete value)
ReportEditConfigController.prototype.checkGroupingLevel = function(levelValue, groupingParams) {
    for(let i = 0; i < groupingParams.length; i++) {
        if(groupingParams[i] === levelValue) {
            return true;
        }
    }
    return false;
};

ReportEditConfigController.prototype.validate = function ()
{
    return true;
};

ReportEditConfigController.prototype.updateUI = function(blinkError)
{
    for (const error in this.possibleErrors)
    {
        if (this.possibleErrors.hasOwnProperty(error))
            this.panelEl.removeClass( this.possibleErrors[error] );
    }

    for (let i=0; i<this.errors.length; i++)
        this.panelEl.addClass(this.errors[i]);

    let errorMsg = "";

     if (this.errors.length === 1)
        errorMsg = this.getErrorMessage(this.errors[0]);
    else if (this.errors.length > 1)
        errorMsg = messageResource.getMessage("report.js.error.exist_invalid_fields");

    this.errorMessageEl.html(errorMsg);
    if (errorMsg && blinkError)
        this.blinkErrorInFooter();

    this.errorTooltipsForSectionsController.updateTooltips( this.errors );
};

ReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    // abstract
    return {};
};

ReportEditConfigController.prototype.removeGroupingLevelsSelectionError = function()
{
    this.errors.remove(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);
    this.updateUI();
};

ReportEditConfigController.prototype.removeCPSelectionError = function()
{
    this.errors.remove(this.possibleErrors.ERROR_EMPTY_CP_SELECTION);
    this.updateUI();
};

ReportEditConfigController.prototype.removeUserSelectionError = function()
{
    this.errors.remove(this.possibleErrors.ERROR_EMPTY_USER_SELECTION);
    this.updateUI();
};

ReportEditConfigController.prototype.getErrorMessage = function( error)
{
    switch (error)
    {
        case this.possibleErrors.ERROR_EMPTY_CP_SELECTION:
            return messageResource.getEscapedMessage("projects_customers_selector.please_select_customer_or_project");
        case this.possibleErrors.ERROR_EMPTY_USER_SELECTION:
            return messageResource.getMessage("report.js.choose_person");
        case this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR:
            return this.groupingSelector.getErrorMessage();
        case this.possibleErrors.ERROR_EMPTY_LEAVE_TYPES_SELECTION:
            return messageResource.getMessage("report.leaves.js.choose_leave_type");
        case this.possibleErrors.ADDITIONAL_ERROR:
            return messageResource.getMessage(this.additionalErrorMessageKey);
    }
    return "";
};

ReportEditConfigController.prototype.blinkErrorInFooter = function ()
{
    this.errorMessageEl.addClass( "blinkDisabled" );
    const self = this;
    window.setTimeout( function ()
                       {
                           self.errorMessageEl.removeClass( "blinkDisabled" );
                       }, 250 );
};

ReportEditConfigController.prototype.configChanged = function() {
    if ( this.configChangedCallback )
        this.configChangedCallback();
};

/**
 * Disable time format selector (and set decimal format) when configuration for CSV
 * Enable time format selector with previous value on HTML configuration
 * @param isCSV true - on CSV , false - on HTML
 */
ReportEditConfigController.prototype.switchTimeFormatBetweenCSVAndHTML = function( isCSV ) {
    if (this.timeFormatSelector){
        const timeFormatSelector = this.timeFormatSelector;
        if (isCSV){
            // if previous value has already been set, it means we are on csv preview tab now,
            // so we must not update previous value again, because we will spoil it
            if (!timeFormatSelector.previousValue)
                timeFormatSelector.previousValue = timeFormatSelector.getValue();
            timeFormatSelector.setActiveItemByValue(TimeFormat.DECIMAL, true);
            timeFormatSelector.disable();
        } else {
            if (timeFormatSelector.previousValue) {
                timeFormatSelector.setActiveItemByValue( timeFormatSelector.previousValue, true );
                // delete previous value after it has been used in order not to get back to it anymore
                timeFormatSelector.previousValue = undefined;
            }
            timeFormatSelector.enable();
        }
    }
};

/**
 * Change grouping selection depending on actual features and right
 * If top level value is not available that all under levels will be shifted to top
 * @param notAvailableLevel - level that now not available
 * @param groupings - levels where can be a not available level
 * @param defaultValueForFirstGrouping - default value for first level (set only all levels are NONE)
 * @returns {*}
 */
ReportEditConfigController.prototype.makeGroupingSelectorValuesAccordingToNotAvailableValueLevel = function(notAvailableLevel, groupings, defaultValueForFirstGrouping){
    for(let i = 0; i < groupings.length; i++){
        if(groupings[i] === notAvailableLevel){
            for(let j = i; j < groupings.length - 1; ++j){
                groupings[j] = groupings[j+1];
            }
            groupings[groupings.length - 1] = ReportGroupingLevel.NONE;
        }
    }
    if(defaultValueForFirstGrouping && groupings[0] === ReportGroupingLevel.NONE){
        groupings[0] = defaultValueForFirstGrouping;
    }
    return groupings;
};

ReportEditConfigController.prototype.setAdditionalError = function(messageKey){
    this.errors.push(this.possibleErrors.ADDITIONAL_ERROR);
    this.additionalErrorMessageKey = messageKey;
};
ReportEditConfigController.prototype.removeAdditionalError = function(){
    this.errors.remove(this.possibleErrors.ADDITIONAL_ERROR);
    this.additionalErrorMessageKey = "";
    this.updateUI();
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ReportEditConfigController.js